import { render, staticRenderFns } from "./price-agreement-update.vue?vue&type=template&id=bb9e15d6&scoped=true"
import script from "./price-agreement-update.vue?vue&type=script&lang=js"
export * from "./price-agreement-update.vue?vue&type=script&lang=js"
import style0 from "./price-agreement-update.vue?vue&type=style&index=0&id=bb9e15d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9e15d6",
  null
  
)

export default component.exports